import React from 'react';
import { SVGProps } from './type';

const IconMaximizeArrow = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.9642 1.34045C11.4119 1.34045 10.9642 1.78817 10.9642 2.34045C10.9642 2.89274 11.4119 3.34045 11.9642 3.34045L12.55 3.34045L9.59046 6.30001C9.19994 6.69054 9.19994 7.3237 9.59046 7.71423C9.98098 8.10475 10.6141 8.10475 11.0047 7.71423L13.9642 4.75467L13.9642 5.34045C13.9642 5.89274 14.4119 6.34045 14.9642 6.34045C15.5165 6.34045 15.9642 5.89274 15.9642 5.34045L15.9642 2.34045C15.9642 1.78817 15.5165 1.34045 14.9642 1.34045L11.9642 1.34045ZM8.33801 10.3809C8.72853 9.99037 8.72853 9.3572 8.33801 8.96668C7.94748 8.57616 7.31432 8.57616 6.92379 8.96668L3.96423 11.9262L3.96423 11.3405C3.96423 10.7882 3.51652 10.3405 2.96423 10.3405C2.41195 10.3405 1.96423 10.7882 1.96423 11.3405L1.96423 14.3405C1.96423 14.8927 2.41195 15.3405 2.96423 15.3405L5.96423 15.3405C6.51652 15.3405 6.96423 14.8927 6.96423 14.3405C6.96423 13.7882 6.51652 13.3405 5.96423 13.3405L5.37845 13.3405L8.33801 10.3809Z"
      transform="translate(0, 1) scale(1.4)"
      fill={fill}
    />
  </g>
);

export default IconMaximizeArrow;
